import React, { useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

const Lightbox = ({ images = [], startIndex = 0, onClose }) => {
  const [index, setIndex] = React.useState(startIndex);

  const next = useCallback(() => setIndex((i) => (i + 1) % images.length), [images.length]);
  const prev = useCallback(() => setIndex((i) => (i - 1 + images.length) % images.length), [images.length]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [index, images, onClose, next, prev]);

  useEffect(() => {
    // lock scroll while open
    const savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = savedOverflow;
    };
  }, []);

  // Block save/copy shortcuts and context menu while lightbox is open
  useEffect(() => {
    const preventKeyShortcuts = (e) => {
      const key = e.key.toLowerCase();
      if ((e.ctrlKey || e.metaKey) && (key === 's' || key === 'c')) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    const preventContextMenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener('keydown', preventKeyShortcuts);
    document.addEventListener('contextmenu', preventContextMenu);
    document.addEventListener('dragstart', preventContextMenu);
    return () => {
      document.removeEventListener('keydown', preventKeyShortcuts);
      document.removeEventListener('contextmenu', preventContextMenu);
      document.removeEventListener('dragstart', preventContextMenu);
    };
  }, []);

  if (!images || images.length === 0) return null;

  const markup = (
    <div className="cb-lightbox" role="dialog" aria-modal="true">
      <div className="cb-lightbox-backdrop" onClick={onClose} />
      <div className="cb-lightbox-content">
        <button className="cb-lightbox-close" onClick={onClose} aria-label="Close">A-</button>
        <button className="cb-lightbox-prev" onClick={prev} aria-label="Previous">?</button>
        <div className="cb-lightbox-image-wrap">
          <img src={images[index]} alt={`Gallery ${index + 1}`} draggable={false} className="protect-img" onContextMenu={(e)=>e.preventDefault()} onDragStart={(e)=>e.preventDefault()} />
          <div className="image-protect-overlay" role="presentation" aria-hidden="true" onContextMenu={(e)=>e.preventDefault()} onMouseDown={(e)=>e.preventDefault()} onTouchStart={(e)=>e.preventDefault()} />
        </div>
        <button className="cb-lightbox-next" onClick={next} aria-label="Next">?</button>
      </div>
    </div>
  );

  // Render modal at document.body root to avoid stacking-context issues
  if (typeof document !== 'undefined') {
    return ReactDOM.createPortal(markup, document.body);
  }

  return markup;
};

export default Lightbox;